import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { SaleService } from '../services/sale.service';
import { Sale } from '../models/sale.model';

@Injectable({
  providedIn: 'root',
})
export class OrderResolver implements Resolve<Sale[] | null> {
  // skipcq
  constructor(
    private _saleService: SaleService,
    private _loadingService: LoadingService,
    private _translateService: TranslateService,
  ) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Sale[] | null> {
    const orderId = route.paramMap.get('orderId');
    if (orderId) {
      if(this._saleService.selectedSale) {
        return of([this._saleService.selectedSale]);
      } else {
        this._loadingService.startLoading();
        return this._saleService.getOrderById(orderId).pipe(tap((val) => {
          this._loadingService.stopLoading();
        }), catchError((e) => {
          this._loadingService.stopLoading();
          console.log(e);
          return of(null);
        }));
      }
    } else {
      throw new Error(this._translateService.instant('errors.missingOrderId'));
    }
  }
}
